// Must stay in lockstep with backend validation (POST /support-chat/messages).
export const MAX_MESSAGE_LENGTH = 4000;

export const STORAGE_KEY_PREFIX = "support-chat:";

// Socket.IO namespace, appended to the API origin in the io() URL.
export const NAMESPACE_PATH = "/support-chat";

// Safety cap on persisted messages — worst case ~800KB at full message length,
// well under localStorage quota.
export const MESSAGES_PERSIST_CAP = 200;

// Data attribute that marks an element as a support-chat trigger. Elements with
// this attribute are excluded from the widget's outside-click handler so a
// click on the trigger doesn't immediately close the widget it just opened.
// Used as both a JSX prop (key) and a CSS selector — keep them in sync via
// `TRIGGER_ATTR_SELECTOR`.
export const TRIGGER_ATTR = "data-support-chat-trigger";
export const TRIGGER_ATTR_SELECTOR = `[${TRIGGER_ATTR}]`;

// The sidebar's own support entry, shared so anything else offering the widget
// (the command palette) shows the word the product already uses. "Get help" is
// what the sidebar says and what reviewers searched for; "Contact support" was
// a second name for one button.
export const SUPPORT_LABEL = "Get help";

// Cap on images kept from one admin reply — Slack allows at most 10 files per
// message, so anything past that is malformed input rather than a real reply.
export const MAX_IMAGES_PER_MESSAGE = 10;

// Assumed dimensions for an admin-reply image the backend sent no size for.
// They only set the aspect ratio of the space reserved before it loads (the
// box is still capped at 240px wide); the real image is letterboxed into it.
export const IMAGE_FALLBACK_WIDTH = 240;
export const IMAGE_FALLBACK_HEIGHT = 180;

// Slack message timestamps are "<seconds>.<microseconds>" with a six-digit
// fraction; parsed as two integers so ordering keeps microsecond precision
// that a single float would lose.
export const SLACK_TS_PATTERN = /^(\d+)\.(\d{6})$/;

// A reply chime plays at most once in this window, so a burst of replies is one sound.
export const CHIME_THROTTLE_MS = 10_000;

// The chime's two notes, rising a fourth (E5 then A5), each faded in and out so
// neither clicks. Gain is kept low: it should be noticed, not startle.
export const CHIME_NOTES = [
  { frequency: 659.25, start: 0 },
  { frequency: 880, start: 0.12 },
] as const;
export const CHIME_NOTE_SECONDS = 0.32;
export const CHIME_PEAK_GAIN = 0.05;
export const CHIME_ATTACK_SECONDS = 0.015;

// Cap on an admin's display name, so a compromised Slack name can't spoof an oversized brand string.
export const MAX_SENDER_NAME_LENGTH = 80;

// The query param that opens the widget on any dashboard page, as the reply email's link does.
export const SUPPORT_OPEN_PARAM = "support";
export const SUPPORT_OPEN_VALUE = "open";
